<h3 mat-dialog-title >
    <div class="d-flex justify-content-center">
        <b>Email Receipt</b>
    </div>
    <hr>
</h3>

<div mat-dialog-content style="width: 500px">
    <div fxLayout="column" class="sectionMargin">
        <div class=" py-2">
            <div [formGroup]="emailForm">
                <div class="col-sm-12">
                    <label>Email</label>
                    <input appBlockQuotes id="idCustomer" name="email" type="text" class="form-control" autocomplete="off"
                        placeholder="Please Insert your email" formControlName="email">
                </div>
                <div class="col-sm-12">
                    <mat-error *ngIf="emailForm.get('email').touched && emailForm.get('email').hasError('required')">Email is required</mat-error>
                    <mat-error *ngIf="emailForm.get('email').touched && emailForm.get('email').hasError('email')">Invalid email format</mat-error>

                </div>
            </div>
        </div>
    </div>
</div>

<div mat-dialog-actions align="center">
  <button mat-button class="selectionButton cancelButton" [mat-dialog-close]="false">Cancel</button>
  <button mat-button class="selectionButton saveButton" (click)="submitEmail()">Submit</button>
</div>